// FOR THE MOMENT IT'S ONLY AN ICON, BUT IT MIGHT BECOME MORE COMPLICATED SO :

import React, { FC } from 'react'
import cx from 'classnames'

import Link, { LinkProps } from '../Link'
import { Icons } from '../Icon'

import * as SC from './styled'

export type FooterLogoProps = MinimalSeoBlock & {
  className?: string
  linkProps?: LinkProps
  title?: string
  // revealed?: boolean // animate on change maybe
}

const FooterLogo: FC<FooterLogoProps> = ({
  className,
  htmlTag,
  linkProps,
  title,
}) => {
  return (
    <SC.Container
      className={cx('FooterLogo', className)}
      as={linkProps?.href ? Link : htmlTag ?? 'div'}
      {...linkProps}
    >
      <SC._Icon
        icon={Icons.logoFooter}
        title={title ?? linkProps?.label ?? linkProps?.text}
      />
    </SC.Container>
  )
}

export default FooterLogo
